import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CONNECTIVITY_TYPE } from 'src/app/domains/connectivity/models/connectivity.model';

@Component({
  selector: 'gdp-connection-type',
  template: '<div [class]="statusClass">{{type}}</div>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConnectionTypeComponent implements OnInit {
  @Input('type') type: CONNECTIVITY_TYPE;
  public statusClass: string;
  private classMapping = {
    [CONNECTIVITY_TYPE.WIFI]: 'vox-chip vox-chip_aquamarine',
    [CONNECTIVITY_TYPE.SIM_CARD]: 'vox-chip vox-chip_aquamarine-text',
  };
  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.statusClass = this.classMapping[this.type];
    this.type = this.type.replace(/#|_/g, ' ') as CONNECTIVITY_TYPE;
  }

}
